import * as PIXI from "pixi.js";
import { SoundManager } from "./sounds";
import { brightnessFilter } from "./global";
import { EnumEventBus, EventBus } from "../EventBus";
import addInteraction from "../lib/addButtonInteraction";


export default class SettingsButton extends PIXI.Sprite {
  constructor(private app_width: number, private app_height: number) {
    super({ texture: PIXI.Assets.get("Info_btn")});

    this.addOptions();
    this.addInteractivity();
  }
  addOptions() {
    this.anchor.set(0.5);
    this.x = -95
    this.y = 12
  }
  addInteractivity() {
    const onHandleTapFunc = () => {
      SoundManager.Btnclick_1SndPlay(); 
      EventBus.emit(EnumEventBus.setSettingsPopup, true);
      this.interactive = false;
      setTimeout(() => this.interactive = true, 500);
    };
    addInteraction(this, onHandleTapFunc, false);
  }
  landScapeAdjust() {
    this.scale.set(1);
    this.x = this.app_width - 184;
    this.y = 62;
  }
  portraitAdjust(){
    this.scale.set(0.66);
    this.x = 600;
    this.y = 685;
  }
}